import ResourcePage from "@/components/ResourcePage";
import PageHeader from "@/components/PageHeader";
import { MEETING_TYPES } from "@/lib/constants";
import { useEventOptions } from "@/hooks/useEventOptions";

const columns = [
  { key: "title", label: "Judul", render: (r) => <span className="font-semibold text-[#1A1A1A]">{r.title}</span> },
  { key: "type", label: "Jenis" },
  { key: "date", label: "Tanggal", date: true },
  { key: "time", label: "Waktu" },
  { key: "venue", label: "Lokasi" },
  { key: "status", label: "Status", badge: true },
];

export default function Meetings() {
  const { options } = useEventOptions();
  const fields = [
    { name: "title", label: "Judul Meeting", required: true, full: true },
    { name: "type", label: "Jenis", type: "select", options: MEETING_TYPES, default: "Technical Meeting" },
    { name: "event_id", label: "Event Terkait", type: "select", options: [{ value: "", label: "— Tidak ada —" }, ...options] },
    { name: "date", label: "Tanggal", type: "date" },
    { name: "time", label: "Waktu" },
    { name: "venue", label: "Lokasi" },
    { name: "status", label: "Status", type: "select", options: ["Scheduled", "Completed", "Cancelled"], default: "Scheduled" },
    { name: "agenda", label: "Agenda", type: "textarea", full: true },
    { name: "notes", label: "Catatan", type: "textarea", full: true },
    { name: "decisions", label: "Keputusan", type: "textarea", full: true },
    { name: "followup", label: "Follow-up Task", type: "textarea", full: true },
  ];
  return (
    <ResourcePage
      resource="meetings" title="Meeting" writeLevel={2}
      columns={columns} fields={fields}
      PageHeaderComp={<PageHeader overline="Technical & Coordination Meeting" title="Meetings" subtitle="Jadwalkan meeting, catat agenda, keputusan, dan tindak lanjut." />}
    />
  );
}
